module.exports = __webpack_public_path__ + "images/breedvelddb74034f584fd60e713c264f3951d7c1.png";